exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".paragraph-title p{line-height:normal;margin-bottom:0;font-size:25px;font-size:1.5625rem}@media (min-width:768px){.paragraph-title p{font-size:26px;font-size:1.625rem}}", ""]);

